import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, HStack, Text, VStack } from '@library';
import type { PageComponent } from '../../content/types/types';
import StoryblokRender from '../../content/components/StoryblokRender';
import DownloadArrowIcon from '../../core/components/icons/DownloadArrowIcon';
import styles from './StaticPageContent.module.scss';

const StaticPageContent = ({ page }: { page: PageComponent }) => {
    const { title: name, body, version, attachment } = page;

    const showHeader = name || version || attachment?.filename;
    return (
        <VStack gap="large">
            {showHeader && (
                <HStack align="center" justify="spaceBetween">
                    <div className={styles.header}>
                        <Heading h1>{name}</Heading>
                    </div>

                    <div className={styles.topVersion}>
                        <div className={styles.versionText}>
                            <Text secondary medium uppercase>
                                {version}
                            </Text>
                        </div>
                        {attachment?.filename && (
                            <a
                                href={attachment.filename}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.downloadLink}
                            >
                                <span className={styles.downloadIcon}>
                                    <DownloadArrowIcon />
                                </span>
                                <FormattedMessage id="download pdf" />
                            </a>
                        )}
                    </div>
                </HStack>
            )}
            <VStack gap="small">
                <StoryblokRender components={body} scrollToElement />
            </VStack>
        </VStack>
    );
};

export default memo(StaticPageContent);
